/**
 * @file Automatically generated by barrelsby.
 */

export * from './layout.component';
